module.exports = __webpack_public_path__ + "static/media/xstream-channels.3c6143e4.svg";